import { render } from "./OpenCloseIconInfo.vue?vue&type=template&id=190e7d7d"
import script from "./OpenCloseIconInfo.vue?vue&type=script&lang=js"
export * from "./OpenCloseIconInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__